import { Popup } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";

export default function HistoryPopup({ onClose, selectedData }) {
  const historyComments = selectedData.row.data.comments;
  return (
    <>
      <Popup
        visible={true}
        onHiding={onClose}
        hideOnOutsideClick={true}
        title="Edit History"
        width={700}
        height="auto"
        resizeEnabled={true}
      >
        <ScrollView height="100%" width="100%">
          <ul className="white">
            {historyComments.length > 0 ? (
              historyComments
                .map((x) => <li key={x.id}>{x.comments}</li>)
                .reverse()
            ) : (
              <div className="white">No Edits</div>
            )}
          </ul>
        </ScrollView>
      </Popup>
    </>
  );
}
